import { action, computed, makeObservable, observable } from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import Feature from "../../Feature";
import errorToast from "../../../components/toast/ErrorToast";
import DashboardDateRangeValidity from "../DashboardDateRangeValidity";

export default class SalesByArticleFeature extends Feature {
    constructor(application, filters) {
        super(application);
        this._filters = filters;
        this._salesByArticle = null;

        makeObservable(this, {
            _salesByArticle: observable,
            salesByArticle: computed,
            setSalesByArticle: action,
        });
    }

    async load() {
        if (!DashboardDateRangeValidity.isValid(this._filters.fromDate, this._filters.toDate)) {
            return;
        }
        await this._getSalesByArticle();
        this.finishLoading();
    }

    setSalesByArticle(data) {
        this._salesByArticle = data;
    }

    get salesByArticle() {
        return this._salesByArticle;
    }

    async _getSalesByArticle() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.setSalesByArticle(response.salesByArticle());
            },
            handlesError: () => {
                errorToast("No se pudieron obtener las ventas por artículo");
                this.setSalesByArticle({ rows: [], total: null });
            },
        });
        return this._application.apiClient().getSalesByArticle(responseHandler, this._filters.fromDate,
                                                               this._filters.toDate, this._filters.channels,
                                                               this._filters.articleCategories,
                                                               this._filters.withoutAllowances);
    }
}
